import React from 'react'
import { Button, Form, Input, Modal, ModalProps, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { Company } from '../company'
import { useUpdateCompany } from '../hooks'
import useForm from '../../hooks/use-form'
import { FormItem } from '../../components/form-item'

type CompanyUpdateModalProps = {
    company: Company
} & Pick<ModalProps, 'open' | 'onCancel'>

export function CompanyUpdateModal({ company, open, onCancel }: CompanyUpdateModalProps) {
    const { t } = useTranslation()
    const updateCompanyMutation = useUpdateCompany(company.id)

    const formProps = useForm({
        mutation: updateCompanyMutation,
        onSuccess: () => {
            notification.success({
                message: t('{{name}} updated', { name: t('Company') }),
            })
            onCancel?.({} as never)
        },
    })

    return (
        <Modal
            title={t('Edit {{name}}', { name: t('Company') })}
            open={open}
            onCancel={onCancel}
            footer={[
                <Button
                    key="cancel"
                    onClick={onCancel}
                >
                    {t('Cancel')}
                </Button>,
                <Button
                    key="update"
                    type="primary"
                    loading={updateCompanyMutation.isPending}
                    onClick={() => formProps.form.submit()}
                >
                    {t('Update')}
                </Button>,
            ]}
            destroyOnClose
        >
            <Form
                {...formProps}
                layout="vertical"
                initialValues={company}
            >
                <FormItem
                    label={t('Company name')}
                    name="name"
                    required
                >
                    <Input placeholder="Evaa B.V." />
                </FormItem>
                <FormItem
                    label={t('Email')}
                    name="email"
                    required
                >
                    <Input placeholder="hi@evaa.chat" />
                </FormItem>
                <FormItem
                    label={t('Address')}
                    name="address"
                    required
                >
                    <Input placeholder="Hoofdstraat 29B" />
                </FormItem>
                <FormItem
                    label={t('Postal code')}
                    name="postalCode"
                    required
                >
                    <Input placeholder="1232 AA" />
                </FormItem>
                <FormItem
                    label={t('City')}
                    name="city"
                    required
                >
                    <Input placeholder="Utrecht" />
                </FormItem>
                <FormItem
                    label={t('VAT number')}
                    name="vatNumber"
                >
                    <Input placeholder="NL123456789B01" />
                </FormItem>
            </Form>
        </Modal>
    )
}
